import { useControllableValue } from 'ahooks';
import classNames from 'classnames';
import React, { useEffect, useMemo, useState, createElement as _createElement } from 'react';
import insertRipple from '../_util/insertRipple';
import { pickDomAttrs } from '../_util/utils';
import Tooltip from '../tooltip';
import { ScrollTabs } from './scroll';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Tabs = props => {
  const {
    tabs,
    iconDirection = 'row',
    //type="toggle"没有"column"设计
    type = 'line',
    size = 'm',
    //iconDirection="column"没有"s"设计
    gap = 'lll',
    destroyInactiveTabPane = false,
    className,
    style,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-tabs");
  const attrs = pickDomAttrs(restProps);
  const [activeKey, onChange] = useControllableValue(props, {
    defaultValue: undefined,
    defaultValuePropName: 'defaultActiveKey',
    valuePropName: 'activeKey',
    trigger: 'onChange'
  });
  const [createdCom, setCreatedCom] = useState([activeKey]);
  useEffect(() => {
    if (destroyInactiveTabPane) {
      createdCom[0] !== activeKey && setCreatedCom([activeKey]);
    } else {
      !createdCom.some(key => key === activeKey) && setCreatedCom([...createdCom, activeKey]);
    }
  }, [activeKey]);
  const availableTabs = useMemo(() => {
    return tabs.filter(item => !item.hidden);
  }, [tabs]);
  const availableTabpanelNum = useMemo(() => {
    return availableTabs.reduce((pre, item) => {
      if (item.component) {
        return pre + 1;
      }
      return pre;
    }, 0);
  }, [availableTabs]);
  return /*#__PURE__*/_jsxs("div", {
    ...attrs.data,
    className: classNames(baseClassName, className, {}),
    style: style,
    children: [/*#__PURE__*/_jsx("div", {
      className: classNames("".concat(baseClassName, "-bar"), {
        ["".concat(baseClassName, "-bar-").concat(type)]: !!type,
        ["".concat(size)]: !!size
      }),
      children: availableTabs === null || availableTabs === void 0 ? void 0 : availableTabs.map(item => {
        const domAttrs = pickDomAttrs(item);
        const icon = item.icon ? /*#__PURE__*/React.cloneElement(item.icon, {
          className: "item-icon"
        }) : null;
        const isActive = activeKey === item.key;
        const element = /*#__PURE__*/_createElement("a", {
          ...domAttrs.data,
          ref: ref => {
            insertRipple({
              className: "".concat(prefixClass, "-ripple"),
              ref
            });
          },
          key: item.key,
          onClick: () => {
            !isActive && !item.disabled && onChange(item.key);
          },
          className: classNames("".concat(baseClassName, "-bar-item"), {
            ["".concat(baseClassName, "-bar-item-selected")]: isActive,
            ["".concat(baseClassName, "-bar-item-disabled")]: !!item.disabled,
            ["".concat(baseClassName, "-bar-item-").concat(iconDirection)]: !!iconDirection,
            ["item-".concat(size)]: !!size,
            ["".concat(type)]: !!type
          })
        }, icon, /*#__PURE__*/_jsx("span", {
          className: "item-name",
          children: item.name
        }));
        if (item.tooltip) {
          let yOffSet = size === 'm' ? 4 : 2;
          if (type === 'line') {
            yOffSet = yOffSet * 2;
          }
          return /*#__PURE__*/_createElement(Tooltip, {
            ...item.tooltip,
            key: item.key,
            align: {
              offset: [0, yOffSet],
              ...item.tooltip.align
            }
          }, element);
        }
        return element;
      })
    }), !!availableTabpanelNum && /*#__PURE__*/_jsx("div", {
      className: classNames("".concat(baseClassName, "-content"), {
        ["mt-".concat(gap)]: gap === 'l' || gap === 'll' || gap === 'lll'
      }),
      style: {
        marginTop: typeof gap === 'number' ? gap : undefined
      },
      children: availableTabs === null || availableTabs === void 0 ? void 0 : availableTabs.map(item => {
        const isActive = activeKey === item.key;
        const isShow = createdCom.some(key => key === item.key);
        return /*#__PURE__*/_jsx("div", {
          className: classNames("".concat(baseClassName, "-content-tabpanel"), {
            ["".concat(baseClassName, "-content-tabpanel-active")]: isActive
          }),
          children: isShow ? item.component : null
        }, item.key);
      })
    })]
  });
};
Tabs.Scroll = ScrollTabs;
export default Tabs;